import type { MaterialSwatchPaletteKey } from '@core/theme/theme';

export enum OrderStatus {
  Draft = 'draft',
  ReadyForProduction = 'ready_for_production',
  InProduction = 'in_production',
  ReadyForRelease = 'ready_for_release',
  Released = 'released',
  Cancelled = 'cancelled',
}

export const ORDER_STATUS_PALETTE: Record<
  OrderStatus,
  MaterialSwatchPaletteKey
> = {
  [OrderStatus.Draft]: 'grey',
  [OrderStatus.ReadyForProduction]: 'yellow',
  [OrderStatus.InProduction]: 'orange',
  [OrderStatus.ReadyForRelease]: 'lightGreen',
  [OrderStatus.Released]: 'green',
  [OrderStatus.Cancelled]: 'red',
};
